import { render } from "./bulkInvoice.vue?vue&type=template&id=16d66378"
import script from "./bulkInvoice.vue?vue&type=script&lang=js"
export * from "./bulkInvoice.vue?vue&type=script&lang=js"

import "./bulkInvoice.vue?vue&type=style&index=0&id=16d66378&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__